module.exports = __webpack_public_path__ + "static/media/tasklist_1579090824161.2c90790b.png";